import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { useEmailHubBilling } from "@circle-react/hooks/useEmailHubBilling";
import { accessGroupRoutes } from "@circle-react/lib/routes/accessGroups";
import { connectRoutes } from "@circle-react/lib/routes/connect";
import { memberTagRoutes } from "@circle-react/lib/routes/memberTags";

import { t } from "@/i18n-js/instance";
import { EmailHubFreePeriodBanner } from "@/react/components/shared/EmailHubFreePeriodBanner";

import { NavGroup } from "../NavGroup";
import { FooterWrapper } from "./FooterWrapper";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const useMemberLinks = (): Link[] => {
  const links: Link[] = [
    {
      label: t("settings_nav_v3.members.manage"),
      path: settingsNavPathV3.members.manage,
      exact: false,
    },
    {
      label: t("settings_nav_v3.members.access_groups"),
      path: accessGroupRoutes.list(),
      exact: true,
    },
  ];

  links.push({
    label: t("settings_nav_v3.connections.title"),
    path: connectRoutes.audienceOverview(),
    exact: true,
  });

  links.push(
    ...[
      {
        label: t("settings_nav_v3.members.segments"),
        path: settingsNavPathV3.members.segments,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.bulk_logs"),
        path: settingsNavPathV3.members.bulk_logs,
        exact: true,
      },
      {
        label: t("settings_nav_v3.members.invitation_links"),
        path: settingsNavPathV3.members.invitation_links,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.onboarding"),
        path: settingsNavPathV3.members.onboarding,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.member_tags"),
        path: memberTagRoutes.list(),
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.profile_fields"),
        path: settingsNavPathV3.members.profile_fields,
        exact: true,
      },
      {
        label: t("settings_nav_v3.members.gamification"),
        path: settingsNavPathV3.members.gamification,
        exact: true,
      },
      {
        label: t("settings_nav_v3.members.activity_logs"),
        path: settingsNavPathV3.members.activity_logs,
        exact: true,
      },
    ],
  );

  return links;
};

export const MemberLinks = () => {
  const { isInFreePeriod } = useEmailHubBilling();
  const links = useMemberLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.members.label")}>
        {links.map(link => (
          <SubNavLinkItem
            key={link.label}
            label={link.label}
            to={link.path}
            isDisabled={link.isDisabled}
            exact={link.exact}
            isNewFeature={link.isNewFeature}
            isBetaFeature={link.isBetaFeature}
          />
        ))}
        {isInFreePeriod && (
          <FooterWrapper>
            <EmailHubFreePeriodBanner />
          </FooterWrapper>
        )}
      </NavGroup.Content>
    </NavGroup>
  );
};
